import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import { videos } from "@/mocks/videos";
import { sortVideos } from "@/utils/video";

export default function LatestVideos() {
  const latest = sortVideos(videos, "latest").slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">
            最新视频
          </h2>
          <p className="mt-1 text-sm text-foreground-600">持续聚合更新，第一时间发现新鲜内容</p>
        </div>
        <Link
          to="/category/entertainment"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          查看更多
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latest.map((v) => (
          <VideoCard key={v.id} video={v} />
        ))}
      </div>
    </section>
  );
}